document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.product-description__tabs-nav-item a');
  const tabContent = document.querySelectorAll('.product-description__tab-content');

  tabs.forEach(tab => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();

      const targetId = tab.getAttribute('href');
      const targetTab = document.querySelector(`${targetId}`);
      // Remove 'active' class from all tabs and content
      tabs.forEach(tab => {
        tab.classList.remove('active');
        tab.parentElement.classList.remove('active');
      });
      tabContent.forEach(content => content.classList.remove('active'));

      // Add 'active' class to the clicked tab and its corresponding content
      tab.classList.add('active');
      tab.parentElement.classList.add('active');
      targetTab.classList.add('active');
    });
  });

  // Add event listeners to the FAQ questions
  const faqQuestions = document.querySelectorAll('.faq-question');
  
  faqQuestions.forEach(question => {
    question.addEventListener('click', () => {
      const faqItem = question.parentElement;
      faqItem.classList.toggle('active');
    });
  });
});